import { useEffect } from 'react';
import ConversationList from '../features/conversations/components/ConversationList';
import ChatInterface from '../features/chat/components/ChatInterface';
import CustomerPanel from '../features/customer/components/CustomerPanel';
import CopilotPanel from '../features/copilot/components/CopilotPanel';
import { useConversationRoute } from '../features/conversations/hooks/useConversationRoute';
import { useIsDesktop } from '../lib/hooks/useMediaQuery';
import { useUIStore } from '../stores';
import { useConversationStore } from '../stores';

export default function DashboardPage() {
  const isDesktop = useIsDesktop();
  const { mobileView, setMobileView } = useUIStore();
  const { selectedConversationId } = useConversationStore();

  // Rendered at /dashboard and /conversations/:sessionId
  useConversationRoute();

  // Reset mobile view when switching to desktop
  useEffect(() => {
    if (isDesktop) setMobileView('list');
  }, [isDesktop, setMobileView]);

  // Go back to list if conversation is deselected on mobile
  useEffect(() => {
    if (!isDesktop && !selectedConversationId && mobileView !== 'list') {
      setMobileView('list');
    }
  }, [isDesktop, selectedConversationId, mobileView, setMobileView]);

  // Desktop: original 3-column layout
  if (isDesktop) {
    return (
      <div className="flex h-full">
        <div className="w-80 flex-shrink-0">
          <ConversationList />
        </div>
        {/* min-w-0: without it the widest thing in the thread (the header's
            button row, say) sets the column's minimum width and shoves
            Customer Info off-screen. */}
        <div className="min-w-0 flex-1">
          <ChatInterface />
        </div>
        <CustomerPanel />
        {/* Right-side drawer overlay; renders itself only when toggled open. */}
        <CopilotPanel />
      </div>
    );
  }

  // Mobile: single-panel view
  return (
    <div className="h-full">
      {mobileView === 'list' && <ConversationList />}
      {mobileView === 'chat' && <ChatInterface />}
      {mobileView === 'customer' && <CustomerPanel />}
      <CopilotPanel />
    </div>
  );
}
